import ApiService from "@/core/services/ApiService";
import { Actions, Mutations } from "@/store/enums/StoreEnums";
import { Module, Action, Mutation, VuexModule } from "vuex-module-decorators";

export interface CompoundCategory {
  id: number;
  name: string;
  sorting: number;
  enabled: boolean;
  compound_type: string;
  compound_type_display: string;
  image_url: string;
  compounds_count: number;
  updated_at: string;
  updated_by: string;
}

export interface CompoundCategoryInfo {
  compound_categories: Array<CompoundCategory>;
  compound_category: CompoundCategory;
}

@Module
export default class CompoundCategoryModule
  extends VuexModule
  implements CompoundCategoryInfo
{
  compound_categories = [] as Array<CompoundCategory>;
  compound_category_count = 0;
  compound_category = {} as CompoundCategory;

  get currentCompoundCategory(): CompoundCategory {
    return this.compound_category;
  }

  get currentCompoundCategories(): Array<CompoundCategory> {
    return this.compound_categories;
  }

  get currentCompoundCategoryCount() {
    return this.compound_category_count;
  }

  @Mutation
  [Mutations.SET_COMPOUND_CATEGORY](compound_category) {
    this.compound_category = compound_category;
  }

  @Mutation
  [Mutations.SET_COMPOUND_CATEGORIES](compound_categories) {
    this.compound_categories = compound_categories;
  }

  @Mutation
  [Mutations.SET_COMPOUND_CATEGORY_COUNT](compound_category_count) {
    this.compound_category_count = compound_category_count;
  }

  @Action
  [Actions.GET_COMPOUND_CATEGORIES](params) {
    ApiService.setHeader();

    let queryString = "?";

    if (params) {
      Object.keys(params).forEach((i) => {
        queryString += "&" + i + "=" + params[i];
      });
    }

    return new Promise<void>((resolve, reject) => {
      ApiService.get("admin/compound_categories", queryString)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_COMPOUND_CATEGORIES,
            data["compound_categories"]
          );
          this.context.commit(
            Mutations.SET_COMPOUND_CATEGORY_COUNT,
            data["total_result"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.GET_COMPOUND_CATEGORY](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.get(`admin/compound_categories/${id}`)
        .then(({ data }) => {
          this.context.commit(
            Mutations.SET_COMPOUND_CATEGORY,
            data["compound_category"]
          );
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.CREATE_COMPOUND_CATEGORY](credentials) {
    ApiService.setHeader();

    const params = {
      compound_category: {
        ...credentials,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.post(`admin/compound_categories`, params)
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.UPDATE_COMPOUND_CATEGORY](credentials) {
    ApiService.setHeader();

    const params = {
      compound_category: {
        ...credentials.values,
      },
    };

    return new Promise<void>((resolve, reject) => {
      ApiService.put(
        `admin/compound_categories/${credentials.id}`,
        params
      )
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }

  @Action
  [Actions.DELETE_COMPOUND_CATEGORY](id) {
    ApiService.setHeader();

    return new Promise<void>((resolve, reject) => {
      ApiService.delete(`admin/compound_categories/${id}`)
        .then(({ data }) => {
          if (data["success"] === false) {
            reject(data["error_msg"]);
            return;
          }
          resolve();
        })
        .catch(({ response }) => {
          this.context.commit(Mutations.SET_ERROR, response.data.errors);
          reject();
        });
    });
  }
}
